export default () => ({
  container: {
    display: 'flex',
    marginRight: '0.3rem',
  },
  icon: {
    marginRight: '0.3rem',
  },
})
